import { PeriscopeList } from '../../../general';
import { PeriscopeRelatedObjectsList } from '../../../general/related-objects';
import { useApiResource } from '@hooks';
import React, { useCallback } from 'react';
export const EntityRelatedObjectsTab = ({ index, sonarObjectId }) => {
    const uri = `/v2/salesforce/SfEntityDefinitions/${sonarObjectId}/related-objects`;
    const { resource, loading } = useApiResource(uri);
    const refs = Object.values(resource !== null && resource !== void 0 ? resource : []);
    const renderRelatedObjects = useCallback((entityReferences) => React.createElement(PeriscopeRelatedObjectsList, { parentIndex: index, relatedObjects: entityReferences }), [index]);
    return React.createElement(PeriscopeList, { list: renderRelatedObjects, loading: loading, results: refs !== null && refs !== void 0 ? refs : [] });
};
